const SUBSCRIPTION_BOOTSTRAP_COMPLETE_EVENT = 'subscription-bootstrap-complete';

type SubscriptionBootstrapCompleteDetail = {
  ownerUserId: string;
};

const completedOwnerIds = new Set<string>();

export const hasSubscriptionBootstrapCompleted = (
  ownerUserId: string | undefined
): boolean => Boolean(ownerUserId && completedOwnerIds.has(ownerUserId));

export const markSubscriptionBootstrapComplete = (
  ownerUserId: string | null | undefined
): void => {
  if (!ownerUserId) {
    return;
  }

  completedOwnerIds.add(ownerUserId);

  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<SubscriptionBootstrapCompleteDetail>(
      SUBSCRIPTION_BOOTSTRAP_COMPLETE_EVENT,
      { detail: { ownerUserId } }
    )
  );
};

export const subscribeToSubscriptionBootstrap = (
  ownerUserId: string,
  callback: () => void
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handler = (event: Event) => {
    const detail = (event as CustomEvent<SubscriptionBootstrapCompleteDetail>).detail;
    if (detail?.ownerUserId === ownerUserId) {
      callback();
    }
  };

  window.addEventListener(
    SUBSCRIPTION_BOOTSTRAP_COMPLETE_EVENT,
    handler as EventListener
  );

  return () => {
    window.removeEventListener(
      SUBSCRIPTION_BOOTSTRAP_COMPLETE_EVENT,
      handler as EventListener
    );
  };
};
